/* eslint-disable import/no-cycle */
import { IntegrationType } from './Integration';

/**
 * Catalog ("apps manifest") types describing each POS integration's configurable
 * settings. These mirror the read-only catalog returned by `GET /v1/integrations/apps`
 * — the shape and metadata of every setting, NOT a site's saved values. The catalog
 * is the source of a `(type, key) -> metadata` join map used to render POS settings
 * wherever they appear.
 *
 * Setting keys and option `value`s are append-only: retired settings are flagged
 * `hidden` rather than deleted or repurposed, so historical saved keys always
 * resolve their name and description.
 */

export enum IntegrationConfigType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  OPTION = 'option',
}

export interface IIntegrationAppConfigOption {
  label: string;
  value: string;
}

export interface IIntegrationAppConfig {
  key: string;
  name: string;
  description?: string;
  type: IntegrationConfigType;
  required?: boolean;
  /** Deprecated/retired settings stay in the catalog flagged hidden so historical keys still resolve. */
  hidden?: boolean;
  ignorable?: boolean;
  permission?: string;
  default?: string;
  min?: number;
  max?: number;
  regex?: string;
  /** Present for `option`-typed settings: the allowed value -> label pairs. */
  options?: IIntegrationAppConfigOption[];
}

export interface IIntegrationApp {
  name: string;
  type: IntegrationType;
  categories: string[];
  imageUrl?: string;
  description?: string;
  config: IIntegrationAppConfig[];
  createdAt?: string;
  updatedAt?: string;
}
